import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useState as uState } from "react";

import React from 'react'

export default function newProduct() {

    const [product, setProduct] = uState({
        productTitle: "",
        productType: "",
        productImage: '',
        productDescription: "",
        productQuantity:'',
        productAmount:''
    })
    const [image, setImage] = uState({
        productImage:''
    })

    const handleChange = (event) => {
        setProduct({
            ...product,
            [event.target.name]: event.target.value,                        
        })
    }
    const handlePhoto = (event) => {
        setImage({
            ...image,
            productImage: event.target.files[0]

        })
    }
    const handleSubmit = async (e) => {
        const formData = new FormData();
        formData.append("productTitle", product.productTitle);
        formData.append("productType", product.productType);
        formData.append("productDescription", product.productDescription);
        formData.append("productQuantity", product.productQuantity);
        formData.append("productAmount", product.productAmount);
        formData.append("productImage", image.productImage);

        const response = await fetch("http://localhost:8000/products/pushProduct", {
            method: "POST",
            body: formData,
        });

            const json = await response.json()

            if (!json.success) {
                alert('error in sending data')
            }
            else {
                alert('send data')
            }

        }

    
  return (
      <> 
          <div className="new">
              <Sidebar />
              <div className="newContainer">
                  <Navbar />
                  <div className="top">
                      <h1>{}</h1>
                  </div>
                  <div className="bottom">
                      <div className="left">
                          <img
                              src={
                                  image.productImage
                                      ? URL.createObjectURL(image.productImage)
                                      : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                              }
                              alt=""
                          />
                      </div>
                      <div className="right">
                          <form onSubmit={handleSubmit} encType="multipart/form-data">
                              <div className="formInput" id="localImg">
                                  <label htmlFor="file">
                                      Image: <DriveFolderUploadOutlinedIcon className="icon" />
                                  </label>
                                  <input
                                      name="productImage"
                                      accept=".png,.jpg,.jpeg,.avif"
                                      type="file"
                                      id="file"
                                      onChange={handlePhoto}
                                      style={{ display: "none" }}
                                  />
                              </div>
                                  <div className="formInput" >
                                      <label>Product Title</label>
                                      <input required onChange={handleChange} value={product.productTitle} name="productTitle" type='text' placeholder='Parcetamol' />
                              </div>
                              <div className="formInput" >
                                  <label>Product Type</label>
                                  <input required onChange={handleChange} value={product.productType} name="productType" type='text' placeholder='Health' pattern="[A-Za-z\s]+"/>
                              </div>
                              <div className="formInput" >
                                  <label>Product Description</label>
                                  <input required onChange={handleChange} value={product.productDescription} name="productDescription" type='text' placeholder='Parcetamol is a...' />
                              </div>
                              <div className="formInput" >
                                  <label>Product Quantity</label>
                                  <input required onChange={handleChange} value={product.productQuantity} name="productQuantity" type='text' placeholder='10mg' pattern="[0-9]+" />
                              </div>
                              <div className="formInput" >
                                  <label>Product Amount</label>
                                  <input required onChange={handleChange} value={product.productAmount} name="productAmount" type='text' placeholder='100' pattern="[0-9]+" />
                              </div>
                              <button type="submit">Send</button>
                          </form>
                      </div>
                  </div>
              </div>
          </div>        
      
      </>
  )
}



